var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('md-autocomplete',{attrs:{"md-fuzzy-search":true,"md-options":_vm.getSanitizedLabels},on:{"md-changed":this.debouncedsearch,"md-selected":_vm.setCompanies},scopedSlots:_vm._u([{key:"md-autocomplete-item",fn:function(ref){
var item = ref.item;
var term = ref.term;
return [_c('md-highlight-text',{attrs:{"md-term":term}},[_vm._v(_vm._s(item.name))])]}}]),model:{value:(_vm.from_company),callback:function ($$v) {_vm.from_company=$$v},expression:"from_company"}},[_c('label',[_vm._v("Для поиска компании начните набор текста")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e1e06ae4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/forms/CompanySearch.vue
// module id = null
// module chunks = 